'use strict';
import {EvaluationAwrcriCtrl} from "./evaluationawrcrictrl.js";
import {evaluationAwrcriModel} from "../../models/evaluationawrcrimodel.js";

export class EvaluationCosolidationCtrl extends EvaluationAwrcriCtrl
{
	postConstruct() {
		this.evaluationA = {};
		this.evaluationB = {};
		this.allEvaluations = [];
		this.cfg.esfaFieldPermission = this.jsDataService.get('cfgEsfaFieldPermission', false);
		let evaluation = this.jsDataService.get('evaluation', {});
		this.evaluation = new evaluationAwrcriModel(evaluation, this.$filter, this.jsDataService);
		if (typeof (evaluation.attachments) === 'object') {
			this.attachments = evaluation.attachments;
		}
		this.initAllEvaluations();
		this.initEvaluations();
		this.evaluation.data_value.countTotal();
	}

	initAllEvaluations() {
		let allEvaluations = this.jsDataService.get('allEvaluations', []);
		for (let oneEvaluation of allEvaluations) {
			this.allEvaluations.push(new evaluationAwrcriModel(oneEvaluation, this.$filter, this.jsDataService));
		}
	}

	initEvaluations() {
		this.evaluationAChanged();
		this.evaluationBChanged();
	}

	evaluationAChanged() {
		if (this.evaluation.data_value.evaluation_id_a > 0) {
			let idStr = new String(this.evaluation.data_value.evaluation_id_a);
			let evla = this.$filter('filter')(this.allEvaluations, {id: idStr.valueOf()}, true);
			if (evla.length > 0) {
				this.evaluationA = evla[0];
				this.claculations();
			} else {
				this.evaluationA = {};
			}
		} else {
			this.evaluationA = {};
		}
	}

	evaluationBChanged() {
		if (this.evaluation.data_value.evaluation_id_b > 0) {
			let idStr = new String(this.evaluation.data_value.evaluation_id_b);
			let evlb = this.$filter('filter')(this.allEvaluations, {id: idStr.valueOf()}, true);
			if (evlb.length > 0) {
				this.evaluationB = evlb[0];
				this.claculations();
			} else {
				this.evaluationB = {};
			}
		} else {
			this.evaluationB = {};
		}
	}

	isSelectedEvaluationA(id) {
		return (this.hasEvaluationA() && this.evaluation.data_value.evaluation_id_a == id);
	}

	isSelectedEvaluationB(id) {
		return (this.hasEvaluationB() && this.evaluation.data_value.evaluation_id_b == id);
	}

	hasEvaluations() {
		return (this.hasEvaluationA() && this.hasEvaluationB());
	}

	hasEvaluationA() {
		return (this.evaluation.data_value.evaluation_id_a > 0 && this.evaluationA instanceof evaluationAwrcriModel);
	}

	hasEvaluationB() {
		return (this.evaluation.data_value.evaluation_id_b > 0 && this.evaluationB instanceof evaluationAwrcriModel);
	}

	getEvaluationA_value(param) {
		if (!this.hasEvaluationA()) {
			return '';
		}
		return this.getEvaluationValue('a', param);
	}

	getEvaluationB_value(param) {
		if (!this.hasEvaluationB()) {
			return '';
		}
		return this.getEvaluationValue('b', param);
	}

	getEvaluationValue(side, param) {
		const src = (side === 'b') ? this.evaluationB : this.evaluationA;
		if (!(src instanceof evaluationAwrcriModel)) {
			return null;
		}
		return src.getValue(param);
	}

	claculations() {
		if (this.hasEvaluations() && this.evaluationA instanceof evaluationAwrcriModel && this.evaluationB instanceof evaluationAwrcriModel) {
			for (let cr in this.evaluation.data_value.criteria) {
				if (typeof (this.evaluationA.data_value.criteria[cr]) !== 'undefined' && typeof (this.evaluationB.data_value.criteria[cr]) !== 'undefined') {
					let avrg = ((this.evaluationA.data_value.criteria[cr].score + this.evaluationB.data_value.criteria[cr].score) / 2);
					this.evaluation.data_value.criteria[cr].score = Number(avrg.toFixed(2));
				} else {
					this.evaluation.data_value.criteria[cr].score = 0;
				}
				if (typeof (this.evaluation.data_value.criteria[cr].type) !== 'undefined' && this.evaluation.data_value.criteria[cr].type == 'group') {
					for (let ccr in this.evaluation.data_value.criteria[cr].criteria) {
						if (typeof (this.evaluationA.data_value.criteria[cr].criteria[ccr]) !== 'undefined' && typeof (this.evaluationB.data_value.criteria[cr].criteria[ccr]) !== 'undefined') {
							let avrg = ((this.evaluationA.data_value.criteria[cr].criteria[ccr].score + this.evaluationB.data_value.criteria[cr].criteria[ccr].score) / 2);
							this.evaluation.data_value.criteria[cr].criteria[ccr].score = Number(avrg.toFixed(2));
						} else {
							this.evaluation.data_value.criteria[cr].criteria[ccr].score = 0;
						}
					}
				}
//				this.evaluation.data_value.criteria[cr].countTotal();
			}
		} else {
			for (let cr in this.evaluation.data_value.criteria) {
				this.evaluation.data_value.criteria[cr].score = 0;
				if (typeof (this.evaluation.data_value.criteria[cr].type) !== 'undefined' && this.evaluation.data_value.criteria[cr].type == 'group') {
					for (let ccr in this.evaluation.data_value.criteria[cr].criteria) {
						this.evaluation.data_value.criteria[cr].criteria[ccr].score = 0;
					}
//					this.evaluation.data_value.criteria[cr].countTotal();
				}
//				this.evaluation.data_value.criteria[cr].data_value.countTotal();
			}
		}
	}

	getEvaluationWpParticipant(side, wpid, pid) {
		const wp = this.getEvaluationWp(side, wpid);
		if (!wp) {
			return null;
		}
		if (typeof (wp.participants[pid]) === 'undefined') {
			return null;
		}
		return wp.participants[pid];
	}

	getEvaluationWp(side, wpid) {
		const src = (side === 'b') ? this.evaluationB : this.evaluationA;
		if (!(src instanceof evaluationAwrcriModel)) {
			return null;
		}
		if (typeof (src.data_value.budgetReduction) === 'undefined') {
			return null;
		}
		if (typeof (src.data_value.budgetReduction.wp[wpid]) === 'undefined') {
			return null;
		}
		return src.data_value.budgetReduction.wp[wpid];
	}

	copyComment(side, wpid, pid) {
		const participant = this.getEvaluationWpParticipant(side, wpid, pid);
		if (!participant) {
			return;
		}
		if (typeof (this.evaluation.data_value.budgetReduction.wp[wpid]) === 'undefined' || typeof (this.evaluation.data_value.budgetReduction.wp[wpid].participants[pid]) === 'undefined') {
			return;
		}
		this.evaluation.data_value.budgetReduction.wp[wpid].participants[pid].comment = participant.comment;
		this.triggerAutosave();
	}

	triggerAutosave() {
		this.$scope.$broadcast('autosaveFormChanged', {});
	}

	copyProposed(side, wpid, pid) {
		const participant = this.getEvaluationWpParticipant(side, wpid, pid);
		if (!participant) {
			return;
		}
		if (typeof (this.evaluation.data_value.budgetReduction.wp[wpid]) === 'undefined' || typeof (this.evaluation.data_value.budgetReduction.wp[wpid].participants[pid]) === 'undefined') {
			return;
		}
		this.evaluation.data_value.budgetReduction.wp[wpid].participants[pid].setProposed(participant.getProposed());
		this.evaluation.data_value.budgetReduction.countTotal();
		this.triggerAutosave();
	}

	isCopyComment(side, wpid, pid) {
		const participant = this.getEvaluationWpParticipant(side, wpid, pid);
		if (!participant) {
			return false;
		}
		return (participant.comment !== '');
	}

	isCopyProposed(side, wpid, pid) {
		const participant = this.getEvaluationWpParticipant(side, wpid, pid);
		if (!participant) {
			return false;
		}
		return (participant.initial > participant.proposed);
	}

	autosavePostFields() {
		return {
			criteria: this.evaluation.data_value.getCriteriaData(),
			fields: this.evaluation.data_value.getFieldsData(),
			budgetReduction: this.evaluation.data_value.budgetReduction,
			evaluations: {
				a: this.evaluation.data_value.evaluation_id_a,
				b: this.evaluation.data_value.evaluation_id_b
			}
//			attachments: this.attachments
		};
	}

	completeEvaluation(ev) {
		if (this.evaluation.status == 2) {
			this.$mdDialog.show({
				controller: ["$scope", "$mdDialog", this.completeDialogCtrl],
				templateUrl: 'application/evaluation_complete.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				fullscreen: true,
//				locals: {
//					evaluation: this.evaluation
//				}
			}).then((results) => {
				const url = this.jsDataService.get('cfgCompleteUrl');
				if (url) {
					this.$scope.basicHttpConfigProcess({
						url: url,
						method: 'POST',
						data: results
					});
				}
			}, () => {
			});
		}
	}

	completeDialogCtrl($scope, $mdDialog) {
		$scope.comment = '';
		$scope.action;
		$scope.close = function () {
			$mdDialog.cancel();
		};

		$scope.submitConfirm = function () {
			$scope.action = 'confirm';
			$scope.submitDialog();
		};
		$scope.submitReturn = function () {
			$scope.action = 'return';
			$scope.submitDialog();
		};

		$scope.submitDialog = function () {
			if (typeof ($scope.action) !== 'undefined' && $scope.action !== '') {
				$mdDialog.hide({
					action: $scope.action,
					comment: $scope.comment
				});
			} else {
				console.log('Undefined action');
			}
		};
	}

	openJustificationCommentModal(ev, participant, wp) {
		const dialogInstance = this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "participant", "commentA", "commentB", this.justificationCommentController],
			templateUrl: 'applications/justification_comment.html',
			parent: angular.element(document.body),
			clickOutsideToClose: true,
			targetEvent: ev,
			fullscreen: true,

			locals: {
				participant: participant,
				commentA: this.getEvaluationWpParticipant('a', wp.id, participant.id).comment,
				commentB: this.getEvaluationWpParticipant('b', wp.id, participant.id).comment
			}
		});

		dialogInstance.then((result) => {
			participant.comment = result.comment;
			this.triggerAutosave();
		}, () => {
		});
	}

	justificationCommentController($scope, $mdDialog, participant, commentA, commentB) {
		$scope.participant = angular.copy(participant);
		$scope.commentA = commentA;
		$scope.commentB = commentB;
		$scope.copyComment = function (text) {
			$scope.participant.comment = text;
		};
		$scope.submit = function ()  {
			$mdDialog.hide($scope.participant);
		};
		$scope.cancel = function () {
			$mdDialog.cancel();
		};
	}
}